module.exports = __webpack_public_path__ + "img/tom_riddles_orphanage.6f494c78.jpg";